module.exports = __webpack_public_path__ + "img/25.3cc1f94a.jpg";